import { useState } from "react";
import PolicySubjectsList, {
  PolicySubjectsListItem,
} from "../../../../../Widgets/Policies/PolicySubjectsList";
import { PolicySubject } from "../../../../../../redux/apiSpecifications/apiClaims";
import { useClaimDetailsContext } from "../../ClaimDetailsContext";
import PolicySubjectDetailsFullScreen from "./PolicySubjects/PolicySubject/PolicySubjectDetailsFullScreen";
import { ButtonConfirm } from "../../../../../Layout/Buttons";
import { useTranslation } from "react-i18next";
import { FlexWrapper } from "../../../../../../style/FlexWrapper";
import AddPolicySubjectProvider, {
  NewPolicySubjectRoleType,
} from "../../../../../Widgets/Subjects/AddPolicySubjectWizard/AddPolicySubjectContext";
import AddPolicySubjectWizardFullScreen from "../../../../../Widgets/Subjects/AddPolicySubjectWizard/AddPolicySubjectWizardFullScreen";
import { Subject } from "../../../../../../redux/apiSpecifications/apiSubjects";
import Error from "../../../../../Modals/Error";

const PolicySubjectsPanel = () => {
  const { t } = useTranslation();

  const {
    claim,
    onRefreshClaim,
    onAddPolicySubjectPromise,
    onDeletePolicySubjectPromise,
  } = useClaimDetailsContext();

  const [policySubject, setPolicySubject] = useState<PolicySubject | undefined>(
    undefined
  );

  const [newPolicySubjectRole, setNewPolicySubjectRole] = useState<
    NewPolicySubjectRoleType | undefined
  >(undefined);

  const policySubjects = claim?.policy!.policySubjects!;

  const canAddOwner =
    policySubjects.filter((_) => _.roleCode === "P").length < 2;

  const canAddcontractor =
    policySubjects.filter((_) => _.roleCode === "C").length === 0;

  const handleOnClosePolicySubjectDetails = () => {
    setPolicySubject(undefined);

    onRefreshClaim()
      .then((_) => console.info(_))
      .catch((error) => {
        Error({ error: error });
      });
  };

  const handleOnAddPolicySubject = (
    addPolicySubjectData: Subject,
    policySubjectRoleCodes: string[]
  ) => {
    console.info(addPolicySubjectData);

    setNewPolicySubjectRole(undefined);

    onAddPolicySubjectPromise(addPolicySubjectData, policySubjectRoleCodes)
      .then((_) => console.info(_))
      .catch((error) => {
        Error({ error: error });
      });
  };

  const handleOnDeletePolicySubject = (
    policySubject: PolicySubjectsListItem
  ) => {
    console.info(policySubject);

    onDeletePolicySubjectPromise(policySubject.id!, policySubject.roleCode!)
      .then((_) => console.info(_))
      .catch((error) => {
        Error({ error: error });
      });
  };

  return (
    <>
      <FlexWrapper gap="1em" justifyContent="flex-end">
        {canAddOwner && (
          <ButtonConfirm onClick={() => setNewPolicySubjectRole("P")}>
            {t("BUTTONS.add-owner")!}
          </ButtonConfirm>
        )}

        {canAddcontractor && (
          <ButtonConfirm onClick={() => setNewPolicySubjectRole("C")}>
            {t("BUTTONS.add-contractor")!}
          </ButtonConfirm>
        )}

        {canAddOwner && canAddcontractor && (
          <ButtonConfirm onClick={() => setNewPolicySubjectRole("C&P")}>
            {t("BUTTONS.add-owner-and-contractor")!}
          </ButtonConfirm>
        )}
      </FlexWrapper>

      <PolicySubjectsList
        data={policySubjects}
        onSelectItem={(policySubjectsListItem) =>
          setPolicySubject(
            claim?.policy?.policySubjects!.find(
              (_) => _.id === policySubjectsListItem.id
            )
          )
        }
        onDeleteItem={handleOnDeletePolicySubject}
      />

      <PolicySubjectDetailsFullScreen
        selectedSubjectId={policySubject ? policySubject.id : undefined} //{selectedSubjectId}
        onClose={handleOnClosePolicySubjectDetails}
      />

      <AddPolicySubjectProvider
        claim={claim!}
        policySubjectRole={newPolicySubjectRole}
      >
        <AddPolicySubjectWizardFullScreen
          open={newPolicySubjectRole !== undefined}
          onAddPolicySubject={handleOnAddPolicySubject}
          onClose={() => setNewPolicySubjectRole(undefined)}
        />
      </AddPolicySubjectProvider>
    </>
  );
};

export default PolicySubjectsPanel;
